export default class GpsPositionEvents {

  constructor(eventsDomain) {
    this.eventsDomain = eventsDomain;
    this.domain = this.eventsDomain.domain;
  }

  contains(name) {
    if (name) {
      //
    }
    return false;
  }

  list(filter) {
    var event = GpsPositionEvents.List.Request(filter);
    return this.eventsDomain.initRequest(event);
  }

  static List = {
    Names: {
      Request: 'GpsPositionListRequestEvent',
      Response: 'GpsPositionListResponseEvent',
    },

    Errors: {
      NotFound: {
        id: 'NotFound',
        msg: 'NotFound',
        details: '',
      },
    },

    Request: function (filter) {
      var event = {
        handler: "GpsPositionListRequestEvent",
        eventName: "GpsPositionListRequestEvent",
        filter: filter.data,
      };
      return event;
    },
  }
}
